import _ from 'lodash';
import { urlFor } from '~/utils/sanity';
import BackgroundImage from '~/components/sanity/BackgroundImage.vue';
import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
import Container from '~/components/sanity/Container.vue';
export default {
  name: 'HowItWorks',
  components: {
    Container,
    SanityBlockContent,
    BackgroundImage
  },
  props: {
    sectionLayout: String,
    header: String,
    cards: Array,
    steps: Array,
    image: Object,
    enhancedImage: Object,
    styles: Object
  },
  data() {
    return {
      urlFor
    };
  },
  computed: {
    showBgImg() {
      if (!this.styles) return false;
      const {
        backgroundImage
      } = this.styles;
      return !_.isUndefined(backgroundImage);
    },
    style() {
      if (!this.styles) return;
      const {
        color,
        backgroundColor
      } = this.styles;
      const style = {
        ...(color && {
          color
        }),
        ...(backgroundColor && {
          backgroundColor
        })
      };
      return style;
    }
  }
};